<template>
  <detail-layout>
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" class="flex flex-row w-full" ref="ruleForm">
          <div class="w-full md:w-11.5/12 lg:max-w-detail lg:mr-auto">
            <base-collapsible-form ref="baseCollapsibleConfigGeneral" 
              v-if="true /* (role === 7 || role === 8)*/"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('license.header_long') }}</h4>
              </template>
              <template slot="content">
                <div class="mb-4" v-if="(role === 7 || role === 8)">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_clients')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumClients, 'integer') }} / {{ $n(form.NumClientsTotal, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumClients" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('license.num_invoices') }}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumInvoices, 'integer') }} / {{ $n(form.NumInvoicesTotal, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumInvoices" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4" v-if="role === 3">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('license.num_volumen_invoices') }}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumVolumen, 'decimal') }} / {{ $n(form.NumVolumenTotal, 'decimal') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumVolumen" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.stored_space')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.StoredSpace, 'integer') }} / {{ $n(form.StoredSpaceTotal, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageStoredSpace" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_companies')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumCompanies, 'integer') }} / {{ $n(form.NumCompaniesTotal, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumCompanies" :color="customColorMethod"></el-progress>
                  </div>
                </div>
                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_users')}}</label>
                  <div class="flex flex-row mt-2">
                    <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumUsers, 'integer') }} / {{ $n(form.NumUsersTotal, 'integer') }}</span>
                    <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumUsers" :color="customColorMethod"></el-progress>
                  </div>
                </div>
              </template>
            </base-collapsible-form>
          
            <!-- <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{msgHeaderModules}}</h3> -->
              <base-collapsible-form ref="baseCollapsibleModules" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderModules}}</h4>
                </template>
                <template slot="content">

                <div v-if="!isGeneralLoading && form.Modulos.length === 0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{msgEmptyModules}}</label>
                </div>
                
                <base-collapsible-form 
                  v-for="(cabecera, index) in form.Modulos"
                  :key="index"
                  :ref="'baseCollapsibleModules'+index" 
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                  <template slot="headerRight">
                    <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{cabecera.Descripcion}}</h4>
                  </template>
                  <template slot="content">

                    <div class="mb-4" 
                      v-for="modulo in cabecera.Modulos"
                      :key="modulo.idModulo">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{modulo.Descripcion}}</label>
                      <div class="flex flex-col md:flex-row">
                        <el-switch 
                          class="switch-text break-normal both-switch" 
                          :disabled="true"
                          v-model="modulo.Contratado" 
                          :active-text="$t('app.active')" 
                          />
                        <label class="text-sm font-semibold dark:text-secondary-600 text-secondary-300 block mb-1 ml-0 md:ml-4">{{modulo.FechaCambioEstado}}</label>
                      </div>
                    </div>

                  </template>
                </base-collapsible-form>

                </template>
              </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleConfigFacturas" v-if="!isRoleDistrbuidor"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.factura_submenu.header')}}</h4>
              </template>
              <template slot="content">
                <div class="mb-6">
                  <el-switch class="switch-text break-normal" v-model="form.PagarAlContabilizar" :active-text="$t('clients.factura_submenu.auto_paid_long')"></el-switch>
                </div>
                <div class="mb-6" v-if="hasAprobationFlowModule">
                  <el-switch class="switch-text break-normal" v-model="form.FlujoAprobacion" :active-text="$t('clients.factura_submenu.active_approbation_flow')"></el-switch>
                </div>
              </template>
            </base-collapsible-form>        

            <base-collapsible-form ref="baseCollapsibleConfigAutofactura" v-if="hasAutofacturaModule && !isRoleDistrbuidor"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.autofactura_submenu.header') }}</h4>
              </template>
              <template slot="content">
                <div class="mb-6">
                  <el-switch class="switch-text break-normal" v-model="form.GenerarUsuarioAuto"
                    :active-text="$t('clients.autofactura_submenu.generate_provider_user')">
                  </el-switch>
                </div>                
                <div class="mb-6">
                  <el-switch class="switch-text break-normal" v-model="form.EnviarMailFactura"
                    :active-text="$t('clients.autofactura_submenu.default_send_email_provider')">
                  </el-switch>
                </div>
                <div class="mb-6">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.autofactura_submenu.default_user_provider_email') }}</label>
                  <el-form-item prop="EmailAutofacturaDefecto">
                    <el-input 
                      clearable 
                      class="w-full"
                      v-model="form.EmailAutofacturaDefecto" 
                      :maxlength="validation.MaxCharEmailProvider" 
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>


            <base-collapsible-form ref="baseCollapsibleConfigUsers" v-if="!isRoleDistrbuidor"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ msgHeaderConfigUsers }}</h4>
              </template>
              <template slot="content">

                <div class="mb-4">
                  <label
                    class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.users_submenu.config_link_user_pool') }}</label>
                  <el-switch class="switch-text break-normal both-switch" v-model="form.VincularUsuariosGrupoGestorInvoiZE"
                    :active-text="$t('app.active')" />
                </div>

                <div class="lg:mb-2">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                    $t('clients.users_submenu.mesesUserPass') }}</label>
                  <el-form-item prop="mesesUserPass">
                    <base-el-select class="w-full" :options="mesesUserPassCaduc" v-model="form.mesesUserPass" clearable filterable />
                  </el-form-item>
                </div>
                <div class="mb-6">
                  <div class="flex flex-col lg:flex-row lg:space-x-4">
                    <div class="flex flex-row items-center mb-4 lg:mb-0">
                      <el-switch class="switch-text break-normal" v-model="form.RequiereOTP"
                        :active-text="$t('clients.users_submenu.otp')"></el-switch>
                      <!-- <base-tooltip-icon size="sm" :content="tooltipRequiereOTP" class="ml-1"/> -->
                    </div>
                    <div class="flex flex-row items-center mb-4 lg:mb-0">
                      <el-switch class="switch-text break-normal" v-model="form.CambioPassPrimerAcceso"
                        :active-text="$t('clients.users_submenu.first_access')"></el-switch>
                      <!-- <base-tooltip-icon size="sm" :content="tooltipCambioPassPrimerAcceso" class="ml-1"/> -->
                    </div>
                  </div>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleWhiteMetadata" v-if="!isRoleDistrbuidor"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <div class="flex items-center mt-4 mb-4">
                  <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_metadatas')}}</h2>
                  <base-tooltip-icon 
                    size="sm" 
                    :content="$t('tooltip.client.contentTooltipMetadataList')" 
                    class="ml-2"/>
                </div>
              </template>
              <template slot="content">
                <el-table
                  ref="whitelistmetadata"
                  :data="form.ListaBlancaMetadatos"
                  style="width: 100%"
                  max-height="250">
                  <el-table-column
                    prop="Nombre"
                    :label="$t('app.name')"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Tipo"
                    :label="$t('app.type')"
                    show-overflow-tooltip
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="120"
                    align="center"
                    :label="$tc('app.actions', 2)">
                    <template slot-scope="scope">
                      <div class="flex flex-row justify-end">
                        <base-button-icon v-if="scope.row.EsLista" @click="addValueToListMetadataToggleDialog(scope)" name="editpencil" mode="core" size="xs"/>
                        <base-button-icon @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core" size="xs" />
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('invoices.metadatos.new_metadato')"
                    @click="newMetadatoToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                  />
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleConfigUsersService" v-if="!isRoleDistrbuidor"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.user_service_submenu.header') }}</h4>
              </template>
              <template slot="content">
                <div class="mb-4" v-if="form.UsuarioServicio">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('users.entity_name') }}</label>
                    <el-form-item prop="UsuarioServicio">
                      <el-input disabled class="w-full" v-model="form.UsuarioServicio" maxlength='50' />
                    </el-form-item>
                  </div>
                  <div>
                    <div class="flex -mx-2 flex-col lg:flex-row">
                      <div class="px-2 w-full lg:mb-0 mb-2">
                        <base-button mode="primary" :text="$t('clients.user_service_submenu.establecer_password')"
                          @click.prevent.stop="toggleDialogs" :loading="isGeneralLoading"
                        />
                      </div>
                      <div class="px-2 w-full lg:mb-0">
                        <base-button mode="primary" :text="$t('clients.user_service_submenu.disable_user')"
                          @click.prevent.stop="disableUserService" :loading="isGeneralLoading"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="mb-4">
                  <el-switch class="switch-text break-normal mb-4" v-model="form.serviceUser"
                    :active-text="$t('clients.user_service_submenu.active_service_user')"></el-switch>
                  <div class="mb-4" v-if="form.serviceUser">
                    <base-password-form-item v-model="form.servicePassword" autocomplete="new-password" name="servicePassword" />
                    <base-password-form-item v-model="form.serviceRepeatPassword" :password="form.servicePassword" autocomplete="new-password" name="serviceRepeatPassword" repeat />
                  </div>
                </div>
              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" />
          <base-button-responsive v-if="!isRoleUserOrConsulta && !isRoleDistrbuidor" mode="primary" :text="$t('app.save')" icon="check"
            @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </template>
      </base-footer>
      <input-create-metadata-dialog
        :dialogOpen="showModalMetadato" 
        @toggleDialog="newMetadatoToggleDialog" 
        @applyDialog="applyNewMetadatoDialog"
        :header="$t('invoices.metadatos.new_metadato_long')" 
        />
      <input-modify-metadata-dialog
        :dialogOpen="showModalAddListMetadata" 
        @toggleDialog="addValueToListMetadataToggleDialog" 
        @applyDialog="applyModifyMetadatoDialog"
        :header="$t('invoices.metadatos.modify_values')" 
        :campoMetadato="actualMetadataSelected"
        :tipoMetadato="actualTypeSelectedNumber"
        />
      <service-generate-password-dialog :dialogOpen="showModifyServicePassword" @toggleDialog="toggleDialogs" />
    </template>
  </detail-layout>
</template>

<script>
import { getClientConfig } from '@/services/clients/getClientConfig'
import { getDistModulos } from '@/services/distributors/getDistModulos'
import { getStoredDataDocs } from '@/services/clients/getStoredDataDocs'
import { updateClientConfig } from '@/services/clients/updateClientConfig'
import { disableServiceUser } from '@/services/clients/disableServiceUser'
import { newServiceUser } from '@/services/clients/newServiceUser'

import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { deleteListMetadatas } from '@/services/clients/lists/deleteListMetadatas'
import { newListMetadatas } from '@/services/clients/lists/newListMetadatas'
import { updateNameMetadata } from '@/services/clients/lists/updateNameMetadata' 

import DetailLayout from '../../components/layout/DetailLayout.vue'
import ServiceGeneratePasswordDialog from '@/components/ServiceGeneratePasswordDialog.vue'
import InputCreateMetadataDialog from '@/components/InputCreateMetadataDialog.vue'
import InputModifyMetadataDialog from '@/components/InputModifyMetadataDialog.vue'

import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'client-admin-detail',
  components: {
    DetailLayout,
    ServiceGeneratePasswordDialog,
    InputCreateMetadataDialog,
    InputModifyMetadataDialog,
  },
  data: function () {
    return {
      showModifyServicePassword: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: i18n.t('configurations.admin_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
      },
      msgHeaderModules: i18n.t('clients.modules'),
      msgHeaderConfigUsers: i18n.t('clients.users_submenu.header'),
      msgEmptyModules: i18n.t('clients.modules_empty'),
      showModalMetadato: false,
      showModalAddListMetadata: false,
      actualMetadataSelected: '',
      actualTypeSelectedNumber: 0,
      form: {
        ListaBlancaMetadatos: [],
        UsuarioServicio: null,
        NumClients: 0,
        StoredSpace: 0,
        NumInvoices: 0,
        NumVolumen: 0,
        NumCompanies: 0,
        NumUsers: 0,

        NumClientsTotal: 0,
        StoredSpaceTotal: 0,
        NumInvoicesTotal: 0,
        NumVolumenTotal: 0,
        NumCompaniesTotal: 0,
        NumUsersTotal: 0,
        mesesUserPass: 0,
        PagarAlContabilizar: false,
        FlujoAprobacion: false,
        Modulos: [],
        VincularUsuariosGrupoGestorInvoiZE: false,
        RequiereOTP: false,
        CambioPassPrimerAcceso: false,
        GenerarUsuarioAuto: false,
        EnviarMailFactura: true,
        EmailAutofacturaDefecto: '',

        serviceUser: false,
        servicePassword: '',
        serviceRepeatPassword: '',
      },
      validation: {
        MaxCharEmailProvider: 60,
      },
      rules: {
      }
    }
  },
  computed: {
    percentageNumClients: function () {
      if (this.form.NumClients === 0 || this.form.NumClientsTotal === 0) return 0
      return Math.round((parseInt(this.form.NumClients) * 100) / parseInt(this.form.NumClientsTotal)) 
    },
    percentageStoredSpace: function () {
      if (this.form.StoredSpace === 0 || this.form.StoredSpaceTotal === 0) return 0
      return Math.round((parseInt(this.form.StoredSpace) * 100) / parseInt(this.form.StoredSpaceTotal)) 
    },
    percentageNumInvoices: function () {
      if (this.form.NumInvoices === 0 || this.form.NumInvoicesTotal === 0) return 0
      return Math.round((parseInt(this.form.NumInvoices) * 100) / parseInt(this.form.NumInvoicesTotal)) 
    },
    percentageNumVolumen: function () {
      if (this.form.NumVolumen === 0 || this.form.NumVolumenTotal === 0) return 0
      return Math.round((parseInt(this.form.NumVolumen) * 100) / parseInt(this.form.NumVolumenTotal)) 
    },
    percentageNumCompanies: function () {
      if (this.form.NumCompanies === 0 || this.form.NumCompaniesTotal === 0) return 0
      return Math.round((parseInt(this.form.NumCompanies) * 100) / parseInt(this.form.NumCompaniesTotal)) 
    },
    percentageNumUsers: function () {
      if (this.form.NumUsers === 0 || this.form.NumUsersTotal === 0) return 0
      return Math.round((parseInt(this.form.NumUsers) * 100) / parseInt(this.form.NumUsersTotal)) 
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    hasAprobationFlowModule: function () {
      return this.$store.getters['auth/hasAprobationFlowModule']
    },
    hasAutofacturaModule: function () {
      return this.$store.getters['auth/hasAutofacturaModule']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isRoleDistrbuidor: function () {
      return this.role === 7 || this.role === 8
    },
    distLibre () {
      return this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    },
    mesesUserPassCaduc: function () {
      return this.$store.getters['config/MESES_USER_PASS_CADUC']
    },
    modulos: function () {
      return this.$store.getters['config/MODULOS']
    },
    cabecerasModulos: function () {
      return this.$store.getters['config/CABECERAS_MODULOS']
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    await this.setClientData()
    // const config = await this.downloadData()
    // this.downloadListMetada()
    // this.setConfig(config)
    // const breadcrumbs = []
    // this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    if (this.role === 7 || this.role === 8) {
      this.$refs.baseCollapsibleConfigGeneral.toggle()
    }
  },
  methods: {
    setClientData: async function () {
      const config = await this.downloadData()
      this.downloadListMetada()
      this.setConfig(config)
      const breadcrumbs = []
      this.header.breadcrumb = breadcrumbs
    },
    formatDate: function (strDate) {
      return i18n.d(strDate, 'numeric_datetime', { date: '-', datetime: ' ' })
    },
    toggleDialogs: function () {
      this.showModifyServicePassword = !this.showModifyServicePassword
    },
    watchFormHandler: function ({ certificate, send_alerts, fechaInicioVig }) {
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    customColorMethod: function (percentage) {
      if (percentage >= 80) {
        return '#ff7c75'
      } else if (percentage >= 60) {
        return '#ffda9e'
      } else {
        return 'var(--primary-400)'
      }
    },
    disableUserService: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await disableServiceUser({ idCliente: this.$route.params.id })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.user_service_disabled_msg'), 'success')
          this.form.UsuarioServicio = null
        }
      } catch (error) {
        this.doFeedback()
      }
      this.$store.commit('setIsLoading', false)
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Campo: row.Nombre }
        const response = await deleteListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newMetadatoToggleDialog () {
      this.showModalMetadato = !this.showModalMetadato
    },
    addValueToListMetadataToggleDialog (scope) {
      this.actualMetadataSelected = scope?.row?.Nombre || ''
      this.actualTypeSelectedNumber = scope?.row?.Tipo || 0
      this.showModalAddListMetadata = !this.showModalAddListMetadata
    },
    applyNewMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: metadato.value, 
          Tipo: metadato.type,
          idCliente: this.id,
        }
        const response = await newListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.newMetadatoToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyModifyMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        metadato.idCliente = this.id
        const response = await updateNameMetadata(metadato)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.addValueToListMetadataToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadListMetada: async function () {
      if (!this.isRoleDistrbuidor) {
        try {
          const result = await getListMetadatas()
          if (result.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', result))
          } else {
            this.form.ListaBlancaMetadatos = result.Respuesta.map(x => ({ Nombre: x.Campo, EsLista: x.EsLista, Tipo: x.Tipo }))
          }
        } catch (error) {
          this.doFeedback()
        } finally {
          // this.resetControlFormChanges()
        }
      }
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            MesesUserPass: this.form.mesesUserPass,
            PagarAlContabilizar: this.form.PagarAlContabilizar,
            FlujoAprobacion: this.form.FlujoAprobacion,
            VincularUsuariosGrupoGestorInvoiZE: this.form.VincularUsuariosGrupoGestorInvoiZE,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
            GenerarUsuarioProveedor: this.form.GenerarUsuarioAuto,
            EmailDefectoAutofactura: this.form.EmailAutofacturaDefecto,
            EnviarMailFactura: this.form.EnviarMailFactura,
          }
          
          const response = await updateClientConfig(payload)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            if (this.form.serviceUser) {
              const payload = {
                idCliente: parseInt(this.$route.params.id), 
                PasswordServicio: this.form.servicePassword,
                GenerateApiKey: false,
                ApiKeyExpireDate: null
              }
              const responseService = await newServiceUser(payload)
              if (responseService.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseService))
              } else {
                this.doFeedback(i18n.t('feedback.success.saved_config_msg'), 'success')
                await this.setClientData()
              }
            }
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: 'companies' })
    },
    downloadData: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        let template
        if (this.role !== 7 && this.role !== 8) {
          template = { ...(await getClientConfig()), ...await this.downloadLicense() }
        } else {
          template = await getDistModulos()
        }
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setConfig: function (config) {
      if (config) {
        if (config.Cliente) {
          this.form.mesesUserPass = config.Cliente.MesesUserPass ? config.Cliente.MesesUserPass : 0
          this.form.PagarAlContabilizar = config.Cliente.PagarAlContabilizar ? config.Cliente.PagarAlContabilizar : false
          this.form.UsuarioServicio = config.Cliente.UsuarioServicio ? config.Cliente.UsuarioServicio : null
          this.form.FlujoAprobacion = config.Cliente.FlujoAprobacion && this.hasAprobationFlowModule ? config.Cliente.FlujoAprobacion : false
          this.form.VincularUsuariosGrupoGestorInvoiZE = config.Cliente.VincularUsuariosGrupoGestorInvoiZE
          this.form.CambioPassPrimerAcceso = config.Cliente.CambioPassPrimerAcceso
          this.form.RequiereOTP = config.Cliente.RequiereOTP
          this.form.GenerarUsuarioAuto = config.Cliente.GenerarUsuarioProveedor
          this.form.EnviarMailFactura = config.Cliente.EnviarMailFactura
          this.form.EmailAutofacturaDefecto = config.Cliente.EmailDefectoAutofactura
        }

        // Modulos
        const finalData = config.Cabeceras
        finalData.forEach(cabecera => {
          cabecera.Descripcion = this.getHeaderName(cabecera)
          cabecera.Modulos.forEach(x => {
            x.Descripcion = this.getModuleName(x)
            if (x.FechaCambioEstado) x.FechaCambioEstado = this.formatDate(x.FechaCambioEstado)
            else x.FechaCambioEstado = this.msgEmptyDate
          })
        })
        this.form.Modulos = finalData

        this.form.NumClients = config.NumeroClientes ? config.NumeroClientes : 0
        this.form.NumVolumen = config.NumVolumenOcupado ? config.NumVolumenOcupado : 0
        this.form.NumInvoices = config.NumFacturasOcupado ? config.NumFacturasOcupado : 0
        this.form.StoredSpace = config.Espacio ? config.Espacio : 0
        this.form.NumCompanies = config.NumeroCIFEmpresas ? config.NumeroCIFEmpresas : 0
        this.form.NumUsers = config.NumeroUsuarios ? config.NumeroUsuarios : 0

        this.form.NumClientsTotal = config.NumeroClientesTotal ? config.NumeroClientesTotal : 0
        this.form.NumVolumenTotal = config.NumVolumenMaximo ? config.NumVolumenMaximo : 0
        this.form.NumInvoicesTotal = config.NumFacturasMaximo ? config.NumFacturasMaximo : 0
        this.form.StoredSpaceTotal = config.EspacioTotal ? config.EspacioTotal : 0
        this.form.NumCompaniesTotal = config.NumeroCIFEmpresasTotal ? config.NumeroCIFEmpresasTotal : 0
        this.form.NumUsersTotal = config.NumeroUsuariosTotal ? config.NumeroUsuariosTotal : 0
      }
    },
    downloadLicense: async function () {
      const params = { }
      try {
        const response = await getStoredDataDocs(params)
        if (response.blnError === false) {
          const dataAlmacenamiento = response.respuesta
          this.form.NumCompanies = dataAlmacenamiento?.EmpresasActuales ?? 0
          this.form.NumUsers = dataAlmacenamiento?.UsuariosActuales ?? 0
          this.form.StoredSpace = dataAlmacenamiento?.AlmacenamientoOcupado ?? 0
          this.form.NumInvoices = dataAlmacenamiento?.NumFacturasOcupado ?? 0
          this.form.NumVolumen = dataAlmacenamiento?.NumVolumenOcupado ?? 0

          this.form.NumCompaniesTotal = dataAlmacenamiento?.EmpresasPermitidos ?? 0
          this.form.NumUsersTotal = dataAlmacenamiento?.UsuariosPermitidos ?? 0
          this.form.StoredSpaceTotal = dataAlmacenamiento?.AlmacenamientoMaximo ?? 0
          this.form.NumInvoicesTotal = dataAlmacenamiento?.NumFacturasMaximo ?? 0
          this.form.NumVolumenTotal = dataAlmacenamiento?.NumVolumenMaximo ?? 0

          return {
            Espacio: dataAlmacenamiento?.AlmacenamientoOcupado ?? 0,
            NumeroCIFEmpresas: dataAlmacenamiento?.EmpresasActuales ?? 0,
            NumeroUsuarios: dataAlmacenamiento?.UsuariosActuales ?? 0,
            NumFacturasOcupado: dataAlmacenamiento?.NumFacturasOcupado ?? 0,
            NumVolumenOcupado: dataAlmacenamiento?.NumVolumenOcupado ?? 0,

            EspacioTotal: dataAlmacenamiento?.AlmacenamientoMaximo ?? 0,
            NumeroCIFEmpresasTotal: dataAlmacenamiento?.EmpresasPermitidos ?? 0,
            NumeroUsuariosTotal: dataAlmacenamiento?.UsuariosPermitidos ?? 0,
            NumFacturasMaximo: dataAlmacenamiento?.NumFacturasMaximo ?? 0,
            NumVolumenMaximo: dataAlmacenamiento?.NumVolumenMaximo ?? 0,
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
      } catch (error) {
        this.doFeedback()
      }
      return {}
    },
    getModuleName: function (modulo) {
      const module = this.modulos.find(x => x.id === modulo.idModulo)
      if (module) {
        return module.Nombre
      }
      console.warn(i18n.t('feedback.warning.unrecognized_module_warn', { module: modulo.idModulo }))
      return modulo.idModulo
    },
    getHeaderName: function (cabecera) {
      const header = this.cabecerasModulos.find(x => x.id === cabecera.idCabecera)
      if (header) {
        return header.Nombre
      }
      console.warn(i18n.t('feedback.warning.unrecognized_module_header_warn', { header: cabecera.idCabecera }))
      return cabecera.idCabecera
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic>img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
